import axios from "axios";
import authAxios from '../../../shared/authAxios';
import { getRefreshToken } from "../../../shared/authAxios";
import { endpoints } from '../../../api/endpoints';

export const userService = {
  login,
  logout,
  check,
  login_sso,
};

function login(username, password) {
  return axios({
    'url': endpoints.user.login,
    'method': 'POST',
    'data': JSON.stringify({ username, password, generate_refresh_token: true, decoded_permissions: true }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => {
    // console.log("Login response", response)
    const r = response.data.data;
    return r;
  });
}

function logout() {
  const refresh_token = getRefreshToken();

  // console.log("logout refresh token", refresh_token);

  if (refresh_token) {
    return authAxios({
      'url': endpoints.user.logout,
      'method': 'POST',
      'data': {
        refresh_token,
      }
    });
  }

  return Promise.resolve(true)
}

function check() {
  return authAxios({
    'url': endpoints.user.check,
    'method': 'GET',
    params: {
      decoded_permissions: true,
    }
  }).then(response => {
    // console.log("Auth check response", response)
    const r = response.data.data;
    return r;
  });
}

function login_sso(username,returnSsoToken) {
  let password = 'nopass'; 
  return axios({
    url: endpoints.user.login,
    method: 'POST',
    data: JSON.stringify({ 
      username, 
      password, 
      generate_refresh_token: true, 
      decoded_permissions: true, 
      enable_sso: true, 
      returnSsoToken 
    }),
    headers: {
      'Content-Type': 'application/json'
    },
    // Accept status codes from 200 up to 399 as valid
    validateStatus: function (status) {
      return status >= 200 && status < 400;
    }
  })
  .then(response => {
    console.log("Login response", response);
    console.log("Response status", response.status);

    // If a redirect is issued (HTTP 302), extract the redirect URL from the header
    if(response.status === 302) {
      const redirectUrl = response.headers['location'] || response.data;
      console.log("Redirecting to", redirectUrl);
      window.location.href = redirectUrl;
      return; // Stop further processing
    }

    // Otherwise, process the response normally
    const r = response.data.data;
    return r;
  })
  .catch(error => {
    console.error("Error in login_sso:", error);
    throw error;
  });
}


